export default "__VITE_ASSET__219b773c__"